import CryptoJS from 'crypto-js'
import { LOCAL_STORAGE_KEYS } from '../constants/storage'

const FE_ENCRYPTION_KEY = process.env.REACT_APP_FE_ENCRYPTION_KEY

export const encryptCredentials = (data) => {
  try {
    return CryptoJS.AES.encrypt(data, FE_ENCRYPTION_KEY).toString()
  } catch (error) {
    console.error('Encrypt Credentials Error - ', error, data)
    return null
  }
}

export const decryptCredentials = (data) => {
  try {
    return CryptoJS.AES.decrypt(data, FE_ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8)
  } catch (error) {
    console.error('Decrypt Credentials Error - ', error, data)
    return null
  }
}

export const setLoginToken = (token) =>
  window.localStorage.setItem('access-token', encryptCredentials(token))

export const setRefreshToken = (token) =>
  window.localStorage.setItem('refresh-token', encryptCredentials(token))

export const getItem = (key) => window.localStorage.getItem(key)

export const setItem = (key, value) => window.localStorage.setItem(key, value)

export const removeItem = (key) => window.localStorage.removeItem(key)

export const getLoginToken = () => {
  if (window.localStorage.getItem('access-token')) return decryptCredentials(window.localStorage.getItem('access-token'))
  else return ''
}

export const getRefreshToken = () => {
  if (window.localStorage.getItem('refresh-token')) return decryptCredentials(window.localStorage.getItem('refresh-token'))
  else return ''
}

export const removeLoginToken = () => {
  const persistedStoreState = window.localStorage.getItem(LOCAL_STORAGE_KEYS.PERSIST_STATE)

  window.localStorage.clear()

  if (persistedStoreState) {
    window.localStorage.setItem(LOCAL_STORAGE_KEYS.PERSIST_STATE, persistedStoreState)
  }
}
